(function () {
  if (window.innerWidth > 767) return;

  var BODY_CLASS = 'mem-editing';
  var blurTimer = null;

  function isMemInput(el) {
    if (!el) return false;
    if (el.id && /^monofield_/.test(el.id)) return true;
    if (el.name && /^properties\[/.test(el.name)) return true;
    if (el.closest && el.closest('#preview-root-app-container')) {
      var tag = el.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
    }
    return false;
  }

  function enterEditing() {
    if (blurTimer) { clearTimeout(blurTimer); blurTimer = null; }
    document.body.classList.add(BODY_CLASS);
    updatePreviewClass();
  }

  function onFieldFocus() {
    enterEditing();
    scrollToFirstInput();
  }

  function maybeExitEditing() {
    if (blurTimer) clearTimeout(blurTimer);
    blurTimer = setTimeout(function () {
      var active = document.activeElement;
      if (!isMemInput(active)) {
        document.body.classList.remove(BODY_CLASS);
      }
    }, 150);
  }

  function bind() {
    var fields = document.querySelectorAll('[id^="monofield_"], #preview-root-app-container input, #preview-root-app-container textarea, #preview-root-app-container select');
    fields.forEach(function (el) {
      if (el.dataset.memEditingBound === '1') return;
      el.dataset.memEditingBound = '1';
      el.addEventListener('focus', onFieldFocus);
      el.addEventListener('blur', maybeExitEditing);
    });
  }

  function hasRenderedPreview() {
    var canvas = document.getElementById('mem-canvas-container');
    if (!canvas) return false;
    // MEM renders a real preview when the canvas contains an SVG that has children.
    var svg = canvas.querySelector('svg');
    if (!svg) return false;
    // A meaningful preview should have visible graphical children (paths, text, groups)
    return svg.querySelector('path, text, g, image') !== null;
  }

  function updatePreviewClass() {
    document.body.classList.toggle('mem-has-preview', hasRenderedPreview());
  }

  function scrollToFirstInput() {
    // Small delay so sticky image CSS has applied and keyboard has started to open
    setTimeout(function () {
      var root = document.getElementById('preview-root-app-container');
      if (!root) return;
      var first = root.querySelector('input[type="text"], textarea, select, input:not([type])');
      if (!first) return;
      // Only scroll if the field is above the sticky image's bottom edge
      var rect = first.getBoundingClientRect();
      var stickyBottom = window.innerHeight * 0.38;
      if (rect.top < stickyBottom + 10) {
        var targetY = window.pageYOffset + rect.top - stickyBottom - 12;
        window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
      }
    }, 220);
  }

  function anchorFirstInput() {
    // Position the first MEM input just below the sticky preview (38vh), with
    // extra headroom so the field's title/label sits in view above the input.
    // Retries while MEM's React app is still mounting the fields.
    var LABEL_HEADROOM = 44;
    var attempts = 0;
    function tryScroll() {
      var root = document.getElementById('preview-root-app-container');
      var first = root && root.querySelector('input[type="text"], textarea, select, input:not([type])');
      if (!first) {
        if (++attempts < 10) setTimeout(tryScroll, 80);
        return;
      }
      var rect = first.getBoundingClientRect();
      var stickyBottom = window.innerHeight * 0.38;
      var targetY = window.pageYOffset + rect.top - stickyBottom - LABEL_HEADROOM;
      window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
    }
    setTimeout(tryScroll, 120);
  }

  function onPersonalizeClick(e) {
    // Skip if already in editing mode — avoids hijacking add-to-cart clicks
    if (document.body.classList.contains(BODY_CLASS)) return;
    var target = e.target;
    if (!target || !target.closest) return;
    var btn = target.closest('button, .cta, [role="button"], a.cta');
    if (!btn) return;
    var txt = (btn.textContent || '').trim().toLowerCase();
    var looksLikePersonalize = txt.indexOf('personalize') !== -1;
    var isStickyCta = !!btn.closest('#mem-sticky-mobile-cta');
    if (looksLikePersonalize || isStickyCta) {
      enterEditing();
      anchorFirstInput();
    }
  }

  function init() {
    bind();
    updatePreviewClass();
    document.addEventListener('click', onPersonalizeClick, true);

    var memRoot = document.getElementById('preview-root-app-container');
    if (memRoot && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        bind();
        updatePreviewClass();
      });
      mo.observe(memRoot, { childList: true, subtree: true, characterData: true, attributes: true });
    }

    // When the canvas itself updates (MEM renders on type), re-check preview state
    if ('MutationObserver' in window) {
      var canvas = document.getElementById('mem-canvas-container');
      if (canvas) {
        var canvasMo = new MutationObserver(updatePreviewClass);
        canvasMo.observe(canvas, { childList: true, subtree: true });
      }
      // Also watch for the canvas being created later
      var bodyMo = new MutationObserver(function () {
        var c = document.getElementById('mem-canvas-container');
        if (c && !c.dataset.memWatched) {
          c.dataset.memWatched = '1';
          new MutationObserver(updatePreviewClass).observe(c, { childList: true, subtree: true });
          updatePreviewClass();
        }
      });
      bodyMo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
